import { ILoginState, IAuthDetails } from './Login-types';

export const loginInitialState: IAuthDetails = {
    userId: null,
    sessionId: null,
    sessionExp: null,
    username: null,
    discord: null,
	aiEnabled: null,
};

const loginState: ILoginState = {
    state: loginInitialState,
    mutations: {
        setAuthDetails(state, authDetails: IAuthDetails) {
            state.userId = authDetails.userId;
            state.sessionId = authDetails.sessionId;
            state.sessionExp = authDetails.sessionExp;
            state.username = authDetails.username;
            state.discord = authDetails.discord;
			state.aiEnabled = authDetails.aiEnabled;
        },
        setDiscordUsername(state, discord: string) {
            state.discord = discord;
        },
        setUsername(state, username: string) {
            state.username = username;
        },
    },
    actions: {
        setAuthDetails({ commit }, authDetails: IAuthDetails) {
            commit('setAuthDetails', authDetails);
        },
        setDiscordUsername({ commit }, discord: string) {
            commit('setDiscordUsername', discord);
        },
        setUsername({ commit }, username: string) {
            commit('setUsername', username);
        },
    },
};

export default loginState;
